export const stemHeight = 78;
export const stemPanelWidth = 160;
export const smoothingFactor = 5;
export const PIXEL_TIME_RATIO = 38.42709584215359;
export const SAMPLE_RATE = 44100;
export const BINS = 625;
export const HEIGHT_SCALE = 1.5625;
